import { ImportSensorsDto,EditSensorDto, GenerateSensorsDto, Sensor, DeleteSensorDto} from "../models/sensor-models";
import { deleteEntityRequest, getRequest, postRequest, putRequest, RequestDataType } from "../../../../services/api";

export const getSensorsForSensorBatch = async (sensorBatchId: string): Promise<Sensor[]>  =>
    await getRequest(`/sensors/${sensorBatchId}`);

export const postImportNewSensors = async (data: Partial<ImportSensorsDto>) =>
    await postRequest("/sensors", data, RequestDataType.Entity);

export const editSensor = async (data: Partial<EditSensorDto>) =>
    await putRequest("/sensors", data, RequestDataType.Entity);

export const deleteSensor = async (deleteSensorDto: DeleteSensorDto) =>
    await deleteEntityRequest("/sensors", deleteSensorDto);

export const toggleManufSensor = async (data: Partial<EditSensorDto[]>) =>
    await putRequest("/sensors/ToggleSensorsManuf", data, RequestDataType.Entity);

export const generateSensors = async (data: Partial<GenerateSensorsDto>) =>
    await postRequest("/sensors/GenerateSensors", data, RequestDataType.Entity);

export const getAllSensors = async (): Promise<Sensor[]>  =>
    await getRequest(`/sensors`);